// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"86cd2d15","443":"55b955f2"}[chunkId] + ".chunk.js";
};